export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7230.20659f22.jpg";